<template>
    <div>
        <ContentHeader path-set-type="append"   />
        <div class="content-wrapper" v-loading="loading">
            <el-row class="content-right">
                <div class="search">
                    <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                    <el-form-item class="item" prop="prId">
                        <el-input v-model="searchForm.prId" placeholder="PR编码" size="small"></el-input>
                    </el-form-item>
                    <el-form-item class="item" prop="prName">
                        <el-input v-model="searchForm.prName" placeholder="PR名称" size="small"></el-input>
                    </el-form-item>
                    <el-form-item class="item" prop="activityName">
                        <el-input v-model="searchForm.activityName" placeholder="活动名称" size="small"></el-input>
                    </el-form-item>
                    <el-form-item class="item" prop="selectbrand">
                        <el-select v-model="searchForm.selectbrand" placeholder="选择品牌" size="small" clearable>
                            <el-option
                            v-for="item in brandOptions"
                            :key="item.brandId"
                            :label="item.brandName"
                            :value="item.abiBrandCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="item" prop="selectChannel">
                        <el-select v-model="searchForm.selectChannel" placeholder="选择渠道" size="small" clearable>
                            <el-option
                            v-for="item in channelOptions"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="item-btn">
                        <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                    </el-form-item>
                    </el-form>
                </div>
                <div class="card-box">
                    <div class="card is-hover-shadow" v-for="(item) in cardData" :key="item.themeId" >
                    <div class="card-left">
                        <div class="left-top">
                            <span>{{item.themeName}}</span>
                        </div>
                        <div class="left-second" v-if="item.gpPrDTO">
                            <span style="margin-right:30px">PR编码：{{item.gpPrDTO.prNumber}}</span>
                            <span item.gpPrDTO>PR名称：{{item.gpPrDTO.prName}}</span>
                        </div>
                        <div class="left-third" v-if="item.gpPrDTO">
                            <div class="left-third-left">
                                <img class="img" src="../../assets/images/gameplan-haerbin.png" alt="">
                                <div class="text" style="color:#409EFF">{{item.gpPrDTO.brandName}}</div>

                            </div>
                            <div class="left-third-right">
                                <img class="img" src="../../assets/images/gameplan-channl.png" alt="">
                                <span class="text">{{getChannel(item.themeChannels,'、')}}</span>
                            </div>
                        </div>
                        <div class="left-last">
                            <span>活动时间：</span>
                            <span>{{getTime(item.themeStartTime)}}</span>
                            <span>-</span>
                            <span>{{getTime(item.themeEndTime)}}</span>
                        </div>
                    </div>
                    <div class="card-right">
                        <div class="right-top"></div>
                        <div class="right-center"></div>
                        <div class="right-btn">
                            <button class="btn-right"  @click="activityDetail(item)">活动详情</button>
                        </div>
                    </div>
                </div>
                </div>
                <div v-if="cardData.length == 0">
                    <!-- style="height:50vh; line-height:50vh;text-align: center;" -->
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <div class="pagination" v-if="cardData.length > 0">
                    <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="searchForm.total"
                    :current-page="searchForm.page"
                    :page-size="searchForm.pageSize"
                    @current-change="handleCurrentChange"
                    />
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import gameplanApi from '../../api/gameplan'
    export default {
      name: 'saleReplace-approval',
      components: {
        ContentHeader,
      },
      data () {
        return {
            searchForm: {
                prId: '', // PR编码
                prName: '', // PR名称
                activityName: '', // 活动名称
                selectChannel: '' , // 选择渠道
                selectbrand: '', // 选择品牌
                page: 1,
                pageSize: 10,
                total:0,
            },
            channelOptions: [], // 渠道下拉菜单
            brandOptions: [], // 品牌下拉菜单
            cardData: [],
            loading:false
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.init()
      },
      mounted () {},
      methods: {
        init () {
            this.getSelectChannel()
            this.getSelectBrand()
            this.getThemelist()
        },
        getChannel(themeChannels,sign){
            if (!themeChannels) {
                themeChannels = []
            }
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(sign)
            if (arr) {
                return arr
            } else {
                return 'null'
            }
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        async getThemelist () {
            this.loading = true
            let params = {
                page: this.searchForm.page,
                pageSize: this.searchForm.pageSize,
                prNumber: this.searchForm.prId,
                prName: this.searchForm.prName,
                themeName: this.searchForm.activityName,
                brandCode: this.searchForm.selectbrand,
                themeChannelScope: this.searchForm.selectChannel,
                // queryEvidence: '01',
                queryReject: '01',
                // queryPocExchange: '01',
            }
            let res = await gameplanApi.getGamepalnReportquery(params)
            if (res.data.resultCode === '0') {
                let pageData = res.data.resultData.pageInfo
                this.searchForm.page = Number(pageData.curPage)
                this.searchForm.total = Number(pageData.totalCounts)
                let cardData = res.data.resultData.themeList
                if (res.data.resultData.themeList !== null) {
                    this.cardData = res.data.resultData.themeList
                } else {
                    this.cardData = []
                }
                this.loading = false
            } else {
                console.log('接口error');
                this.loading = false
            }
        },
        async getSelectChannel () {
            // name=gpThemeChannelMap&type=list或map
            let params = {
                name:'gpThemeChannelMap',
                type:'list'
            }
            let data =  await gameplanApi.getGamepalnChannelquery(params)
            this.channelOptions = data.data.resultData.gpThemeChannelMap
        },
        async getSelectBrand () {
            let data =  await gameplanApi.getGamepalnBrandquery()
            this.brandOptions = data.data.resultData.btmpBrandDTOList
        },
        // 搜索
        queryForm (val) {
            this.$refs.searchForm.validate((valid) => {
            if (valid) {
                this.searchForm.page = 1
                this.getThemelist()

            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        // 重置
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.searchForm.page = 1
            this.getThemelist()
        },
        // 活动详情
        activityDetail (item) {
            this.$router.push(
                {path:'/gameplan/saleReplace-approval-detail',
                query:{
                    'activityId':item.activityId,
                    'themeId':item.themeId,
                    'themeStartTime':this.getTime(item.themeStartTime),
                    'themeEndTime':this.getTime(item.themeEndTime),
                    'themeName':item.themeName,
                    'themeChannels':this.getChannel(item.themeChannels,'&'),
                    'brandName':item.gpPrDTO.brandName,
                    'prName':item.gpPrDTO.prName,
                    'prNumber':item.gpPrDTO.prNumber,
                    }
                }
            )
        },
        handleCurrentChange (val) {
          this.searchForm.page = val
          this.getThemelist()
        },
      }
    }
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        padding: 0 auto;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .search {
            margin: 0 auto;
            width: 900px;
            .searchForm {
                width: 100%;
                .item {
                    width:130px;
                }
                .item-btn {
                    margin-left: 30px;
                }
            }
        }
        .card-box {
            .card {
                margin: 0 auto;
                width: 880px;
                display: flex;
                justify-content: flex-start;
                padding: 10px 10px;
                background-color: #FFFFFF ;
                border-radius: 8px;
                font-size: 14px;
                margin-bottom: 20px;
                .card-left {
                    text-align: left;
                    color: #101010;
                    width: 80%;
                    .left-top {
                        line-height: 27px;
                        font-size: 18px;
                        font-weight: 600;
                        word-wrap: break-word;
                        word-break: normal;
                        word-break: break-all;
                    }
                    .left-second {
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 5px;
                    }
                    .left-third {
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 8px;
                        display: flex;
                        justify-content: flex-start;
                        .left-third-left {
                            display: flex;
                            justify-content: flex-start;
                            color: #409EFF;
                            margin-right: 20px;
                            .img {
                                width: 20px;
                                margin-right: 3px;
                                height: 20px;
                            }
                        }
                        .left-third-right {
                            flex: 1;
                            display: flex;
                            justify-content: flex-start;
                            .img {
                                width: 20px;
                                margin-right: 3px;
                                height: 20px;
                            }
                            .text {
                                margin: 0px 3px 0px 3px ;
                                color: #EDB60A;
                            }
                        }
                    }
                    .left-last {
                        font-size: 14px;
                        line-height: 20px;
                        color: #999999;
                        margin-top: 8px;
                    }
                }
                .card-right {
                    flex: 1;
                    text-align: right;
                    .right-top {
                        height: 27px;
                        line-height: 27px;
                        color: #CD1231 ;
                        font-size: 18px;
                    }
                    .right-center {
                        margin-top: 26px;
                        height: 20px;
                        line-height: 20px;
                    }
                    .right-btn {
                        margin-top: 6px;
                        .btn-right {
                            width: 84px;
                            height: 32px;
                            border-radius: 4px;
                            border: 1px solid #CD1231;
                            background-color: #FFFFFF;
                            font-size: 14px;
                            color: #CD1231;
                            text-align: center;
                            font-family: Microsoft Yahei;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
            text-align: center;
        }
      }
    }
</style>
